import { Link } from "react-router-dom";
import { XCircle, Phone } from "lucide-react";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function PaymentCancel() {
    useDocumentTitle("Payment Canceled · A1 Screening", "Your A1 Screening payment was canceled — no charge was made.");
    return (
        <div className="a1-container a1-section max-w-lg text-center" data-testid="payment-cancel-page">
            <div className="a1-card py-12">
                <XCircle size={36} className="mx-auto mb-3" style={{ color: "var(--color-text-muted)" }} />
                <h1 className="text-2xl mb-2">Payment canceled</h1>
                <p className="text-sm mb-6" style={{ color: "var(--color-text-muted)" }}>
                    No charge was made. You can reopen your payment link any time, or call us if you'd rather pay another way.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <a href="tel:+12394347306" className="a1-btn-secondary inline-flex justify-center"><Phone size={16} /> Call 239-434-7306</a>
                    <Link to="/" className="a1-btn-primary inline-flex justify-center">Back to A1 Screening</Link>
                </div>
            </div>
        </div>
    );
}
